import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { exerciseCardFeatures } from '../../data/exerciseCardFeatures';
export function ExerciseCardDetail() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-38" data-mp="369uixrfdja6k">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-39" data-mp="31bayjvgfi6gb">
        <SectionTag icon="🗂️" tone="accent" data-id="element-40" data-mp="31cvpzc7g599y">
          Material real
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-41" data-mp="2uq8hzhr7rgv">
          Cada uno de los 240 ejercicios incluye
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl px-4 sm:px-6" data-id="element-42" data-mp="3p6vtdrrp62hw">
        <div className="grid gap-3 rounded-2xl border border-primary/10 bg-paper p-6 shadow-card-light sm:grid-cols-2 sm:p-8" data-id="element-43" data-mp="3k9wxp4sdxnhl">
          {exerciseCardFeatures.map((feature, i) => <m.div key={feature} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i % 5 * 0.05
        }} className="flex items-start gap-2.5 rounded-xl bg-white px-4 py-3 shadow-card-light" data-id="element-44" data-mp="gswx0p0tcf3v" data-mpi={i}>
              <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-45" data-mp="1el4vbbju5rc4" />
              <span className="text-sm leading-relaxed text-ink" data-id="element-46" data-mp="1jkra3pfbbfn1">{feature}</span>
            </m.div>)}
        </div>
      </div>
    </section>;
}